import * as React from 'react'
import { Link } from 'react-router-dom'
import { ErrorBoundary } from '@framework/Components';
import LoginDropdown from '@extensions/Authorization/Login/LoginDropdown'
import * as AuthClient from '@extensions/Authorization/AuthClient'
import OmniboxAutocomplete from '@extensions/Omnibox/OmniboxAutocomplete'
import { GlobalModalContainer } from "@framework/Modals"
import { ajaxGet } from "@framework/Services"
import * as AppContext from "@framework/AppContext"
import Notify from "@framework/Frames/Notify"
import CultureDropdown from "@extensions/Translation/CultureDropdown"
import { IsolationMixin } from "@extensions/Isolation/Signum.Entities.Isolation";
import SidebarContainer from "@extensions/Toolbar/SidebarContainer";
import { VersionChangedAlert } from '@framework/Frames/VersionChangedAlert';
import * as LicenseClient from "@saturn/License/LicenseClient"
import { OmniboxPermission } from '@extensions/Omnibox/Signum.Entities.Omnibox';
import { getMixin } from '@framework/Signum.Entities';
import { JavascriptMessage } from '@framework/Signum.Entities'

const WorkflowDropdown = React.lazy(() => import('@extensions/Workflow/Workflow/WorkflowDropdown'));
const ToolbarRenderer = React.lazy(() => import('@extensions/Toolbar/Templates/ToolbarRenderer'));
const IsolationDropdown = React.lazy(() => import('@extensions/Isolation/IsolationDropdown'));
const MessageDropdown = React.lazy(() => import('@saturn/Collaboration/Templates/MessageDropdown'));
//const FeedbackAlert = React.lazy(() => import('../App/Zarazma/Templates/Feedback/FeedbackAlert'));

export default function Layout() {

  const [refreshId, setRefreshId] = React.useState(0);
  const [sideMenuVisible, setSideMenuVisible] = React.useState(true);
  const [showLicenseInfo, setShowLicenseInfo] = React.useState(true);

  function resetUI() {
    setRefreshId(rID => rID + 1);
  };

  React.useEffect(() => {
    AppContext.setResetUI(resetUI);
    ajaxGet<boolean>({ url: "~/api/showLicenseInfo" })
      .then(show => setShowLicenseInfo(show))
      .done();

    return () => AppContext.setResetUI(() => { });
  }, []);

  function handleToggle() {
    setSideMenuVisible(currentIsVisible => !currentIsVisible);
  }

  const currentUser = AuthClient.currentUser();

  return (
    <ErrorBoundary>
      <div id="main" key={refreshId}>
        <div>
         
          <nav className="navbar navbar-light navbar-expand">
            <div className="navbar-brand d-flex">
              <Link to="~/" style={{ color: "gray" }}>
                <img style={{ display: "inline" }} className="mr-2" src={AppContext.toAbsoluteUrl("~/api/smallLogo")} />
                {showLicenseInfo && <CustomerNameComponent customerName={LicenseClient.licenseInfo.customerName} />}
              </Link>
              <button className="btn btn-link ml-auto" onClick={handleToggle}>
                <span className="navbar-toggler-icon" />
              </button>
            </div>
            {currentUser &&
              <div className="navbar-nav mr-auto">
                {AuthClient.isPermissionAuthorized(OmniboxPermission.ViewOmnibox) &&
                  <li>
                    <div className="omnibox-container" style={{ width: "200px" }}>
                      <OmniboxAutocomplete inputAttrs={{ className: "form-control" }} />
                    </div>
                  </li>}
                {currentUser && <React.Suspense fallback={JavascriptMessage.loading.niceToString()}><WorkflowDropdown /></React.Suspense>}
                {currentUser && LicenseClient.isLicensed("Collaboration") && <React.Suspense fallback={JavascriptMessage.loading.niceToString()}><MessageDropdown /></React.Suspense>}
                {currentUser && <React.Suspense fallback={JavascriptMessage.loading.niceToString()}><ToolbarRenderer location="Top" tag={false} /></React.Suspense>}
              </div>}
            <div className="navbar-nav ml-auto">
              {currentUser && LicenseClient.isLicensed("Isolation") && getMixin(currentUser, IsolationMixin).isolation == null &&
                <React.Suspense fallback={JavascriptMessage.loading.niceToString()}><IsolationDropdown /></React.Suspense>}
              <CultureDropdown />
              {currentUser && <LoginDropdown switchUserVisible={false} />}
            </div>
          </nav>
        </div>
        <Notify />
        <div id="main-container">
          <SidebarContainer
            sidebarVisible={currentUser && sideMenuVisible}
            sidebarContent={<React.Suspense fallback={JavascriptMessage.loading.niceToString()}><ToolbarRenderer location="Side" /></React.Suspense>}>
            {/*currentUser && <React.Suspense fallback={JavascriptMessage.loading.niceToString()}><FeedbackAlert /></React.Suspense>*/}
            <VersionChangedAlert />
            {Layout.switch}
          </SidebarContainer>
        </div>
        <GlobalModalContainer />
        <div id="footer">
          <div className="container" dir="ltr" style={{ fontFamily: "Segoe UI" }}>
            {/*<p className="text-muted">© {moment(LicenseClient.licenseInfo.now).format("YYYY")} <a href={LicenseClient.licenseInfo.companyURL}>{LicenseClient.licenseInfo.companyName}</a>. All rights reserved.</p>*/}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

Layout.switch = undefined as React.ReactElement<any> | undefined;

export function CustomerNameComponent(p: { customerName: string }) {
  return (
    <span>{p.customerName}</span>
  );
}




